export const ibLogin = process.env.GATSBY_IB_LINKS_LOGIN || 'https://auth.bankera.com/login';
export const ibSignUp = process.env.GATSBY_IB_LINKS_SIGNUP || 'https://auth.bankera.com/signup';
